import { render, staticRenderFns } from "./DefaultSidebar.vue?vue&type=template&id=fb7128f2&scoped=true"
import script from "./DefaultSidebar.vue?vue&type=script&lang=js"
export * from "./DefaultSidebar.vue?vue&type=script&lang=js"
import style0 from "./DefaultSidebar.vue?vue&type=style&index=0&id=fb7128f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7128f2",
  null
  
)

export default component.exports